import { api } from './api';

export const getCSRFToken = (params, cancelToken) => api.get(
  '/csrf-token',
  {
    cancelToken,
    params,
  },
);

export const noop = {};
